import config from "config";
import { authGetJson } from "utilities/msalFetches";
import { throwIfResponseError } from "apis/apiUtilities";

export interface IPdfGenerationJobResponse {
  JobId: string;
  SwId: number;
  SwTitle: string;
  IsPublished: boolean | null;
  PdfType: string;
  Status: string;
  RequestedAt: string;
  PdfGeneratedOn: string | null;
  ContainerName: string | null;
  FilePath: string | null;
  Message: string | null;
  RequestedBy: string;
}

export interface IPdfGenerationDownloadResult {
  blob: Blob;
  filename: string;
}

class PdfGenerationApi {
  public async getPdfGenerationJob(jobId: string): Promise<IPdfGenerationJobResponse> {
    const response = await authGetJson(
      config.endpoints.pdfGeneration.getJob.replace("{jobId}", jobId)
    );

    await throwIfResponseError(response);
    return await response.json();
  }

  public async getPdfGenerationDownload(jobId: string): Promise<IPdfGenerationDownloadResult> {
    const response = await authGetJson(
      config.endpoints.pdfGeneration.getDownload.replace("{jobId}", jobId)
    );

    await throwIfResponseError(response);

    return {
      blob: await response.blob(),
      filename:
        response.headers.get("Content-Disposition")?.split("filename*=UTF-8''")[1] ??
        `PDF_${jobId}.pdf`,
    };
  }
}

export default new PdfGenerationApi();
